import React from 'react';
import styled from 'styled-components';
import { mobileOnly } from '../headerLinks';
import hamburger from './hamburger';

const Wrapper = styled.div`
  ${hamburger}
`;

const HamburgerContainer = styled.button`
  ${mobileOnly};
  padding: 0 !important;
  cursor: pointer;
  :focus {
    outline: none;
  }
`;

export const Hamburger = ({ active, onClick }) => (
  <Wrapper>
    <HamburgerContainer
      className={'hamburger hamburger--squeeze' + (active ? ' is-active' : '')}
      onClick={onClick}
      type="button"
    >
      <span className="hamburger-box">
        <span className="hamburger-inner" />
      </span>
    </HamburgerContainer>
  </Wrapper>
);

export default Hamburger;



// WEBPACK FOOTER //
// ./src/components/hamburger/index.js